import { render, staticRenderFns } from "./ReportStats.vue?vue&type=template&id=bb0baf92"
import script from "./ReportStats.vue?vue&type=script&lang=js"
export * from "./ReportStats.vue?vue&type=script&lang=js"
import style0 from "./ReportStats.vue?vue&type=style&index=0&id=bb0baf92&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports